export default __webpack_public_path__ + "static/media/cards_en.dd4c408b.png";